export default "__VITE_ASSET__8f57cc23__"